import { Flex, Image } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { Subheading } from "./Text";

export const ShieldHeader = ({ children }: PropsWithChildren) => {
  return (
    <Flex
      direction={{ base: "column", lg: "row-reverse" }}
      pr={{ base: 0, md: 0, lg: 168 }}
      justify="space-between"
      align={{ base: "stretch", lg: "flex-end" }}
      rowGap={24}
      mb={10}
    >
      <Image
        src="/Shields.png"
        h={{ base: 250, md: 294, lg: 375 }}
        maxW={{ base: 500, lg: "100%" }}
        objectFit={"contain"}
      />
      <Flex
        direction="column"
        alignItems="flex-end"
        flexGrow={1}
        maxW={{ base: "80%", md: 500 }}
        borderBottom="3px solid"
        borderColor="green.500"
      >
        <Subheading
          size={{ base: "lg", md: "xl" }}
          ml={{ base: "30%", md: "20%", lg: "25%" }}
          mb={6}
        >
          {children}
        </Subheading>
      </Flex>
    </Flex>
  );
};
